export const TrenchSafety = {
  xOffset: 0,
  yOffset: 0,
  pixels: [
    {
      x: 6,
      y: 1
    },
    {
      x: 6,
      y: 2
    },
    {
      x: 7,
      y: 1
    },
    {
      x: 8,
      y: 1
    },
    {
      x: 10,
      y: 1
    },
    {
      x: 9,
      y: 1
    },
    {
      x: 11,
      y: 1
    },
    {
      x: 7,
      y: 2
    },
    {
      x: 8,
      y: 2
    },
    {
      x: 9,
      y: 2
    },
    {
      x: 10,
      y: 2
    },
    {
      x: 11,
      y: 2
    },
    {
      x: 8,
      y: 3
    },
    {
      x: 8,
      y: 4
    },
    {
      x: 8,
      y: 5
    },
    {
      x: 8,
      y: 6
    },
    {
      x: 8,
      y: 7
    },
    {
      x: 8,
      y: 8
    },
    {
      x: 8,
      y: 9
    },
    {
      x: 8,
      y: 10
    },
    {
      x: 8,
      y: 11
    },
    {
      x: 9,
      y: 11
    },
    {
      x: 9,
      y: 10
    },
    {
      x: 9,
      y: 9
    },
    {
      x: 9,
      y: 8
    },
    {
      x: 9,
      y: 7
    },
    {
      x: 9,
      y: 6
    },
    {
      x: 9,
      y: 5
    },
    {
      x: 9,
      y: 4
    },
    {
      x: 9,
      y: 3
    },
    {
      x: 14,
      y: 1
    },
    {
      x: 14,
      y: 2
    },
    {
      x: 14,
      y: 3
    },
    {
      x: 14,
      y: 4
    },
    {
      x: 14,
      y: 5
    },
    {
      x: 14,
      y: 6
    },
    {
      x: 14,
      y: 7
    },
    {
      x: 14,
      y: 8
    },
    {
      x: 14,
      y: 9
    },
    {
      x: 14,
      y: 10
    },
    {
      x: 14,
      y: 11
    },
    {
      x: 15,
      y: 1
    },
    {
      x: 15,
      y: 2
    },
    {
      x: 15,
      y: 3
    },
    {
      x: 15,
      y: 4
    },
    {
      x: 15,
      y: 5
    },
    {
      x: 15,
      y: 6
    },
    {
      x: 15,
      y: 7
    },
    {
      x: 15,
      y: 8
    },
    {
      x: 15,
      y: 9
    },
    {
      x: 15,
      y: 10
    },
    {
      x: 15,
      y: 11
    },
    {
      x: 16,
      y: 1
    },
    {
      x: 16,
      y: 2
    },
    {
      x: 17,
      y: 1
    },
    {
      x: 17,
      y: 2
    },
    {
      x: 18,
      y: 1
    },
    {
      x: 18,
      y: 2
    },
    {
      x: 19,
      y: 2
    },
    {
      x: 19,
      y: 3
    },
    {
      x: 19,
      y: 4
    },
    {
      x: 19,
      y: 5
    },
    {
      x: 18,
      y: 3
    },
    {
      x: 18,
      y: 4
    },
    {
      x: 18,
      y: 5
    },
    {
      x: 18,
      y: 6
    },
    {
      x: 17,
      y: 5
    },
    {
      x: 16,
      y: 5
    },
    {
      x: 16,
      y: 6
    },
    {
      x: 17,
      y: 6
    },
    {
      x: 16,
      y: 7
    },
    {
      x: 17,
      y: 7
    },
    {
      x: 16,
      y: 8
    },
    {
      x: 17,
      y: 8
    },
    {
      x: 17,
      y: 9
    },
    {
      x: 18,
      y: 9
    },
    {
      x: 18,
      y: 10
    },
    {
      x: 19,
      y: 10
    },
    {
      x: 18,
      y: 11
    },
    {
      x: 19,
      y: 11
    },
    {
      x: 22,
      y: 1
    },
    {
      x: 22,
      y: 2
    },
    {
      x: 22,
      y: 3
    },
    {
      x: 22,
      y: 4
    },
    {
      x: 22,
      y: 5
    },
    {
      x: 22,
      y: 6
    },
    {
      x: 22,
      y: 7
    },
    {
      x: 22,
      y: 8
    },
    {
      x: 22,
      y: 9
    },
    {
      x: 22,
      y: 10
    },
    {
      x: 22,
      y: 11
    },
    {
      x: 23,
      y: 11
    },
    {
      x: 23,
      y: 10
    },
    {
      x: 23,
      y: 9
    },
    {
      x: 23,
      y: 8
    },
    {
      x: 23,
      y: 7
    },
    {
      x: 23,
      y: 6
    },
    {
      x: 23,
      y: 5
    },
    {
      x: 23,
      y: 4
    },
    {
      x: 23,
      y: 3
    },
    {
      x: 23,
      y: 2
    },
    {
      x: 23,
      y: 1
    },
    {
      x: 24,
      y: 1
    },
    {
      x: 24,
      y: 2
    },
    {
      x: 25,
      y: 1
    },
    {
      x: 25,
      y: 2
    },
    {
      x: 26,
      y: 1
    },
    {
      x: 26,
      y: 2
    },
    {
      x: 27,
      y: 1
    },
    {
      x: 27,
      y: 2
    },
    {
      x: 24,
      y: 5
    },
    {
      x: 25,
      y: 5
    },
    {
      x: 26,
      y: 5
    },
    {
      x: 24,
      y: 6
    },
    {
      x: 25,
      y: 6
    },
    {
      x: 26,
      y: 6
    },
    {
      x: 24,
      y: 10
    },
    {
      x: 25,
      y: 10
    },
    {
      x: 26,
      y: 10
    },
    {
      x: 27,
      y: 10
    },
    {
      x: 27,
      y: 11
    },
    {
      x: 26,
      y: 11
    },
    {
      x: 25,
      y: 11
    },
    {
      x: 24,
      y: 11
    },
    {
      x: 30,
      y: 1
    },
    {
      x: 30,
      y: 2
    },
    {
      x: 30,
      y: 3
    },
    {
      x: 30,
      y: 4
    },
    {
      x: 30,
      y: 5
    },
    {
      x: 30,
      y: 6
    },
    {
      x: 30,
      y: 7
    },
    {
      x: 30,
      y: 8
    },
    {
      x: 30,
      y: 9
    },
    {
      x: 30,
      y: 10
    },
    {
      x: 30,
      y: 11
    },
    {
      x: 31,
      y: 11
    },
    {
      x: 31,
      y: 10
    },
    {
      x: 31,
      y: 9
    },
    {
      x: 31,
      y: 8
    },
    {
      x: 31,
      y: 7
    },
    {
      x: 31,
      y: 6
    },
    {
      x: 31,
      y: 5
    },
    {
      x: 31,
      y: 4
    },
    {
      x: 31,
      y: 3
    },
    {
      x: 31,
      y: 1
    },
    {
      x: 31,
      y: 2
    },
    {
      x: 32,
      y: 4
    },
    {
      x: 32,
      y: 5
    },
    {
      x: 33,
      y: 5
    },
    {
      x: 33,
      y: 6
    },
    {
      x: 34,
      y: 6
    },
    {
      x: 34,
      y: 7
    },
    {
      x: 35,
      y: 7
    },
    {
      x: 35,
      y: 8
    },
    {
      x: 36,
      y: 8
    },
    {
      x: 36,
      y: 9
    },
    {
      x: 36,
      y: 10
    },
    {
      x: 36,
      y: 11
    },
    {
      x: 37,
      y: 11
    },
    {
      x: 37,
      y: 10
    },
    {
      x: 37,
      y: 9
    },
    {
      x: 37,
      y: 8
    },
    {
      x: 37,
      y: 7
    },
    {
      x: 36,
      y: 7
    },
    {
      x: 36,
      y: 6
    },
    {
      x: 37,
      y: 6
    },
    {
      x: 37,
      y: 5
    },
    {
      x: 36,
      y: 5
    },
    {
      x: 36,
      y: 4
    },
    {
      x: 37,
      y: 4
    },
    {
      x: 37,
      y: 3
    },
    {
      x: 36,
      y: 3
    },
    {
      x: 36,
      y: 2
    },
    {
      x: 37,
      y: 2
    },
    {
      x: 37,
      y: 1
    },
    {
      x: 36,
      y: 1
    },
    {
      x: 40,
      y: 2
    },
    {
      x: 41,
      y: 1
    },
    {
      x: 42,
      y: 1
    },
    {
      x: 43,
      y: 1
    },
    {
      x: 44,
      y: 1
    },
    {
      x: 42,
      y: 2
    },
    {
      x: 41,
      y: 2
    },
    {
      x: 43,
      y: 2
    },
    {
      x: 44,
      y: 2
    },
    {
      x: 45,
      y: 2
    },
    {
      x: 45,
      y: 3
    },
    {
      x: 44,
      y: 3
    },
    {
      x: 40,
      y: 3
    },
    {
      x: 40,
      y: 4
    },
    {
      x: 40,
      y: 5
    },
    {
      x: 40,
      y: 6
    },
    {
      x: 40,
      y: 7
    },
    {
      x: 40,
      y: 9
    },
    {
      x: 40,
      y: 8
    },
    {
      x: 40,
      y: 10
    },
    {
      x: 41,
      y: 11
    },
    {
      x: 41,
      y: 10
    },
    {
      x: 42,
      y: 10
    },
    {
      x: 41,
      y: 3
    },
    {
      x: 41,
      y: 4
    },
    {
      x: 41,
      y: 5
    },
    {
      x: 41,
      y: 6
    },
    {
      x: 41,
      y: 7
    },
    {
      x: 41,
      y: 8
    },
    {
      x: 41,
      y: 9
    },
    {
      x: 42,
      y: 11
    },
    {
      x: 43,
      y: 11
    },
    {
      x: 44,
      y: 10
    },
    {
      x: 43,
      y: 10
    },
    {
      x: 44,
      y: 11
    },
    {
      x: 45,
      y: 10
    },
    {
      x: 45,
      y: 9
    },
    {
      x: 44,
      y: 9
    },
    {
      x: 48,
      y: 1
    },
    {
      x: 48,
      y: 2
    },
    {
      x: 48,
      y: 3
    },
    {
      x: 48,
      y: 4
    },
    {
      x: 48,
      y: 5
    },
    {
      x: 48,
      y: 6
    },
    {
      x: 48,
      y: 7
    },
    {
      x: 48,
      y: 8
    },
    {
      x: 48,
      y: 9
    },
    {
      x: 48,
      y: 10
    },
    {
      x: 48,
      y: 11
    },
    {
      x: 49,
      y: 11
    },
    {
      x: 49,
      y: 10
    },
    {
      x: 49,
      y: 9
    },
    {
      x: 49,
      y: 8
    },
    {
      x: 49,
      y: 7
    },
    {
      x: 49,
      y: 6
    },
    {
      x: 49,
      y: 5
    },
    {
      x: 49,
      y: 4
    },
    {
      x: 49,
      y: 3
    },
    {
      x: 49,
      y: 2
    },
    {
      x: 49,
      y: 1
    },
    {
      x: 50,
      y: 5
    },
    {
      x: 50,
      y: 6
    },
    {
      x: 51,
      y: 6
    },
    {
      x: 51,
      y: 5
    },
    {
      x: 52,
      y: 1
    },
    {
      x: 52,
      y: 3
    },
    {
      x: 52,
      y: 4
    },
    {
      x: 52,
      y: 2
    },
    {
      x: 52,
      y: 5
    },
    {
      x: 52,
      y: 6
    },
    {
      x: 52,
      y: 7
    },
    {
      x: 52,
      y: 8
    },
    {
      x: 52,
      y: 9
    },
    {
      x: 52,
      y: 10
    },
    {
      x: 52,
      y: 11
    },
    {
      x: 53,
      y: 11
    },
    {
      x: 53,
      y: 10
    },
    {
      x: 53,
      y: 8
    },
    {
      x: 53,
      y: 9
    },
    {
      x: 53,
      y: 7
    },
    {
      x: 53,
      y: 5
    },
    {
      x: 53,
      y: 6
    },
    {
      x: 53,
      y: 4
    },
    {
      x: 53,
      y: 3
    },
    {
      x: 53,
      y: 2
    },
    {
      x: 53,
      y: 1
    },
    {
      x: 7,
      y: 26
    },
    {
      x: 7,
      y: 27
    },
    {
      x: 8,
      y: 27
    },
    {
      x: 9,
      y: 27
    },
    {
      x: 10,
      y: 27
    },
    {
      x: 11,
      y: 27
    },
    {
      x: 8,
      y: 28
    },
    {
      x: 9,
      y: 28
    },
    {
      x: 10,
      y: 28
    },
    {
      x: 11,
      y: 26
    },
    {
      x: 11,
      y: 25
    },
    {
      x: 10,
      y: 24
    },
    {
      x: 9,
      y: 23
    },
    {
      x: 8,
      y: 22
    },
    {
      x: 7,
      y: 21
    },
    {
      x: 7,
      y: 19
    },
    {
      x: 7,
      y: 20
    },
    {
      x: 8,
      y: 18
    },
    {
      x: 9,
      y: 18
    },
    {
      x: 10,
      y: 18
    },
    {
      x: 8,
      y: 19
    },
    {
      x: 9,
      y: 19
    },
    {
      x: 10,
      y: 19
    },
    {
      x: 11,
      y: 19
    },
    {
      x: 11,
      y: 20
    },
    {
      x: 15,
      y: 20
    },
    {
      x: 15,
      y: 21
    },
    {
      x: 15,
      y: 22
    },
    {
      x: 15,
      y: 23
    },
    {
      x: 15,
      y: 24
    },
    {
      x: 15,
      y: 25
    },
    {
      x: 15,
      y: 26
    },
    {
      x: 15,
      y: 27
    },
    {
      x: 15,
      y: 28
    },
    {
      x: 16,
      y: 19
    },
    {
      x: 17,
      y: 18
    },
    {
      x: 17,
      y: 19
    },
    {
      x: 18,
      y: 19
    },
    {
      x: 18,
      y: 23
    },
    {
      x: 18,
      y: 24
    },
    {
      x: 19,
      y: 28
    },
    {
      x: 19,
      y: 27
    },
    {
      x: 19,
      y: 26
    },
    {
      x: 19,
      y: 25
    },
    {
      x: 19,
      y: 24
    },
    {
      x: 19,
      y: 23
    },
    {
      x: 19,
      y: 22
    },
    {
      x: 19,
      y: 21
    },
    {
      x: 19,
      y: 20
    },
    {
      x: 16,
      y: 23
    },
    {
      x: 17,
      y: 23
    },
    {
      x: 16,
      y: 24
    },
    {
      x: 17,
      y: 24
    },
    {
      x: 23,
      y: 28
    },
    {
      x: 23,
      y: 27
    },
    {
      x: 23,
      y: 26
    },
    {
      x: 23,
      y: 25
    },
    {
      x: 23,
      y: 24
    },
    {
      x: 23,
      y: 23
    },
    {
      x: 23,
      y: 22
    },
    {
      x: 23,
      y: 21
    },
    {
      x: 23,
      y: 20
    },
    {
      x: 23,
      y: 19
    },
    {
      x: 23,
      y: 18
    },
    {
      x: 24,
      y: 18
    },
    {
      x: 25,
      y: 18
    },
    {
      x: 26,
      y: 18
    },
    {
      x: 27,
      y: 18
    },
    {
      x: 27,
      y: 19
    },
    {
      x: 25,
      y: 19
    },
    {
      x: 24,
      y: 19
    },
    {
      x: 26,
      y: 19
    },
    {
      x: 24,
      y: 22
    },
    {
      x: 25,
      y: 22
    },
    {
      x: 26,
      y: 22
    },
    {
      x: 24,
      y: 23
    },
    {
      x: 25,
      y: 23
    },
    {
      x: 26,
      y: 23
    },
    {
      x: 31,
      y: 28
    },
    {
      x: 31,
      y: 27
    },
    {
      x: 31,
      y: 26
    },
    {
      x: 31,
      y: 25
    },
    {
      x: 31,
      y: 24
    },
    {
      x: 31,
      y: 23
    },
    {
      x: 31,
      y: 22
    },
    {
      x: 31,
      y: 21
    },
    {
      x: 31,
      y: 20
    },
    {
      x: 31,
      y: 19
    },
    {
      x: 31,
      y: 18
    },
    {
      x: 32,
      y: 18
    },
    {
      x: 33,
      y: 18
    },
    {
      x: 34,
      y: 18
    },
    {
      x: 35,
      y: 18
    },
    {
      x: 32,
      y: 19
    },
    {
      x: 33,
      y: 19
    },
    {
      x: 34,
      y: 19
    },
    {
      x: 35,
      y: 19
    },
    {
      x: 32,
      y: 22
    },
    {
      x: 33,
      y: 22
    },
    {
      x: 34,
      y: 22
    },
    {
      x: 32,
      y: 23
    },
    {
      x: 33,
      y: 23
    },
    {
      x: 34,
      y: 23
    },
    {
      x: 32,
      y: 27
    },
    {
      x: 33,
      y: 27
    },
    {
      x: 34,
      y: 27
    },
    {
      x: 35,
      y: 27
    },
    {
      x: 32,
      y: 28
    },
    {
      x: 33,
      y: 28
    },
    {
      x: 34,
      y: 28
    },
    {
      x: 35,
      y: 28
    },
    {
      x: 39,
      y: 18
    },
    {
      x: 40,
      y: 18
    },
    {
      x: 41,
      y: 18
    },
    {
      x: 42,
      y: 18
    },
    {
      x: 43,
      y: 18
    },
    {
      x: 40,
      y: 19
    },
    {
      x: 39,
      y: 19
    },
    {
      x: 41,
      y: 19
    },
    {
      x: 42,
      y: 19
    },
    {
      x: 43,
      y: 19
    },
    {
      x: 41,
      y: 28
    },
    {
      x: 41,
      y: 27
    },
    {
      x: 41,
      y: 26
    },
    {
      x: 41,
      y: 25
    },
    {
      x: 41,
      y: 24
    },
    {
      x: 41,
      y: 23
    },
    {
      x: 41,
      y: 22
    },
    {
      x: 41,
      y: 21
    },
    {
      x: 41,
      y: 20
    },
    {
      x: 47,
      y: 18
    },
    {
      x: 47,
      y: 19
    },
    {
      x: 47,
      y: 20
    },
    {
      x: 48,
      y: 21
    },
    {
      x: 49,
      y: 21
    },
    {
      x: 50,
      y: 21
    },
    {
      x: 48,
      y: 22
    },
    {
      x: 49,
      y: 22
    },
    {
      x: 50,
      y: 22
    },
    {
      x: 51,
      y: 18
    },
    {
      x: 51,
      y: 19
    },
    {
      x: 51,
      y: 20
    },
    {
      x: 49,
      y: 28
    },
    {
      x: 49,
      y: 27
    },
    {
      x: 49,
      y: 25
    },
    {
      x: 49,
      y: 24
    },
    {
      x: 49,
      y: 23
    },
    {
      x: 49,
      y: 26
    },
    {
      x: 12,
      y: 19
    },
    {
      x: 12,
      y: 20
    },
    {
      x: 12,
      y: 25
    },
    {
      x: 12,
      y: 26
    },
    {
      x: 12,
      y: 27
    },
    {
      x: 11,
      y: 24
    },
    {
      x: 11,
      y: 28
    },
    {
      x: 11,
      y: 18
    },
    {
      x: 9,
      y: 22
    },
    {
      x: 8,
      y: 26
    },
    {
      x: 8,
      y: 20
    },
    {
      x: 8,
      y: 21
    },
    {
      x: 20,
      y: 20
    },
    {
      x: 20,
      y: 21
    },
    {
      x: 20,
      y: 22
    },
    {
      x: 20,
      y: 23
    },
    {
      x: 20,
      y: 24
    },
    {
      x: 20,
      y: 25
    },
    {
      x: 20,
      y: 26
    },
    {
      x: 20,
      y: 27
    },
    {
      x: 20,
      y: 28
    },
    {
      x: 19,
      y: 19
    },
    {
      x: 18,
      y: 18
    },
    {
      x: 16,
      y: 20
    },
    {
      x: 16,
      y: 21
    },
    {
      x: 16,
      y: 22
    },
    {
      x: 16,
      y: 25
    },
    {
      x: 16,
      y: 26
    },
    {
      x: 16,
      y: 27
    },
    {
      x: 16,
      y: 28
    },
    {
      x: 28,
      y: 18
    },
    {
      x: 28,
      y: 19
    },
    {
      x: 27,
      y: 22
    },
    {
      x: 27,
      y: 23
    },
    {
      x: 24,
      y: 20
    },
    {
      x: 24,
      y: 21
    },
    {
      x: 24,
      y: 24
    },
    {
      x: 24,
      y: 25
    },
    {
      x: 24,
      y: 26
    },
    {
      x: 24,
      y: 27
    },
    {
      x: 24,
      y: 28
    },
    {
      x: 36,
      y: 18
    },
    {
      x: 36,
      y: 19
    },
    {
      x: 35,
      y: 22
    },
    {
      x: 35,
      y: 23
    },
    {
      x: 36,
      y: 27
    },
    {
      x: 36,
      y: 28
    },
    {
      x: 32,
      y: 20
    },
    {
      x: 32,
      y: 21
    },
    {
      x: 32,
      y: 24
    },
    {
      x: 32,
      y: 25
    },
    {
      x: 32,
      y: 26
    },
    {
      x: 44,
      y: 18
    },
    {
      x: 44,
      y: 19
    },
    {
      x: 42,
      y: 20
    },
    {
      x: 42,
      y: 21
    },
    {
      x: 42,
      y: 23
    },
    {
      x: 42,
      y: 22
    },
    {
      x: 42,
      y: 24
    },
    {
      x: 42,
      y: 25
    },
    {
      x: 42,
      y: 26
    },
    {
      x: 42,
      y: 27
    },
    {
      x: 42,
      y: 28
    },
    {
      x: 52,
      y: 18
    },
    {
      x: 52,
      y: 19
    },
    {
      x: 52,
      y: 20
    },
    {
      x: 51,
      y: 21
    },
    {
      x: 51,
      y: 22
    },
    {
      x: 50,
      y: 23
    },
    {
      x: 50,
      y: 24
    },
    {
      x: 50,
      y: 25
    },
    {
      x: 50,
      y: 26
    },
    {
      x: 50,
      y: 27
    },
    {
      x: 50,
      y: 28
    },
    {
      x: 48,
      y: 18
    },
    {
      x: 48,
      y: 19
    },
    {
      x: 48,
      y: 20
    }
  ]
};
